import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../reducers/rootReducer';

export const isCompanySelector = createSelector(
  (state: RootState) => state.flows.answers,
  (answers) =>
    answers.find(({ id }) => id === 'policy_holder.person_type')?.answer ===
      'LEGAL' ||
    (!!answers.find(({ id }) => id === 'company.cbe') &&
      answers.find(({ id }) => id === 'policy_holder.person_type')?.answer !==
        'NATURAL'),
);
